var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center ma-2"},[_c('v-snackbar',{attrs:{"absolute":"","right":"","top":"","timeout":"3000","color":"info"},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }